import { render, staticRenderFns } from "./CustomerComplaintInvestigationDetail.vue?vue&type=template&id=95dd0c7c&"
import script from "./CustomerComplaintInvestigationDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintInvestigationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports